import { format } from 'date-fns';
import { dateFormats } from '../constants';

const normalizeSearchValue = (value) =>
  String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const getNotificationClient = ({ location, appliance, thing }) =>
  location?.parkname || appliance?.description || thing?.thing || '-';

export const getNotificationMachine = ({ thing, appliance }) =>
  thing?.thing || appliance?.description || '-';

export const getNotificationVariable = ({ alarm }) =>
  alarm?.variable?.name ||
  alarm?.variable?.ihmname ||
  alarm?.variableName ||
  alarm?.ihmname ||
  '-';

export const getNotificationDate = ({ date, hour, lastUpdate }) => {
  if (date && hour) return `${hour} ${date}`;
  if (date) return date;

  if (lastUpdate) {
    const parsedDate = new Date(lastUpdate);

    if (!Number.isNaN(parsedDate.getTime())) {
      return format(parsedDate, dateFormats.TIME_DATE);
    }
  }

  return '-';
};

export const getNotificationStatus = ({ visualized }) =>
  visualized ? 'Visualizado' : 'Não visualizado';

export const getNotificationAlarmType = ({ alarm, isAlarm }) => {
  const explicitType =
    alarm?.type?.label || alarm?.type?.name || alarm?.type || alarm?.label;

  return explicitType || (isAlarm ? 'Alarme' : 'Atenção');
};

export const matchesNotificationFilter = (notification, filterText) => {
  const normalizedFilter = normalizeSearchValue(filterText.trim());

  if (!normalizedFilter) return true;

  return [
    getNotificationClient(notification),
    getNotificationMachine(notification),
    getNotificationVariable(notification),
    getNotificationDate(notification),
    getNotificationStatus(notification),
    getNotificationAlarmType(notification),
  ].some((value) => normalizeSearchValue(value).includes(normalizedFilter));
};
